import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { propStr } from '../../../../../../helpers/custom-prop-types';
import FileExcelIcon from '../../../../../Icon/Svg/FileExcelIcon';
import FilePptxIcon from '../../../../../Icon/Svg/FilePptxIcon';
import FileTextIcon from '../../../../../Icon/Svg/FileTextIcon';
import FileWordIcon from '../../../../../Icon/Svg/FileWordIcon';
import Image from '../../../../../Ui/Common/Image';
const AdditionalFilesRowThumbnail = (props) => {
    const { extension: rawExtension, thumbnail } = props;
    const extension = useMemo(() => (rawExtension || '').toLowerCase(), [rawExtension]);
    if (thumbnail) {
        return (_jsx("div", Object.assign({ className: 'additional_file_thumbnail' }, { children: _jsx(Image, { alt: '', isObjectFit: true, src: thumbnail, useImage: true }) })));
    }
    if (['pptx', 'ppt'].includes(extension)) {
        return (_jsx("div", Object.assign({ className: 'additional_file_svg_icon' }, { children: _jsx(FilePptxIcon, { className: 'office_icon' }) })));
    }
    if (['xlsx', 'xlsx'].includes(extension)) {
        return (_jsx("div", Object.assign({ className: 'additional_file_svg_icon' }, { children: _jsx(FileExcelIcon, { className: 'office_icon' }) })));
    }
    if (['docx', 'doc'].includes(extension)) {
        return (_jsx("div", Object.assign({ className: 'additional_file_svg_icon' }, { children: _jsx(FileWordIcon, { className: 'office_icon' }) })));
    }
    return (_jsx("div", Object.assign({ className: 'additional_file_svg_icon' }, { children: _jsx(FileTextIcon, { className: 'text_icon' }) })));
};
AdditionalFilesRowThumbnail.propTypes = {
    extension: propStr().isRequired,
    thumbnail: propStr().isRequired,
};
export default AdditionalFilesRowThumbnail;
